const NewExcelJSON = [
  {
    type: 0,
    MovementType: "Y",
    OriginCountry: "Y",
    OriginCity: "Y",
    OriginCityPinCode: "Y",
    DestinationCountry: "Y",
    DestinationCity: "Y",
    DestinationCityPinCode: "Y",
    IncoTerm: "Y",
    Cargotype: "Y",
    CargoAdd: "1",
  },
  {
    type: 1,
    MovementType: "Y",
    OriginCountry: "Y",
    OriginCity: "Y",
    OriginCityPinCode: "Y",
    DestinationCountry: "Y",
    DestinationCity: "Y",
    DestinationCityPinCode: "Y",
    IncoTerm: "Y",
    Cargotype: "Y",
    CargoAdd: "2",
  },
];

export default NewExcelJSON;
